<template>
    <div class="col-md-6 col-xl-4 mb-4">
        <div class="bg-white">
            <div class="card-img-wrapper">
                <img :src="`${publicPath}${image_bg}`" class="card-img-top" :alt="title">
            </div>
            <div class="card-body pt-4 pt-xl-5 pb-5 px-5">
                <div class="card-title h4 text-orange font-weight-bold">{{title}}</div>
                <div class="card-text">{{text}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Location",
        props: [
            'title',
            'image_bg',
            'text'
        ],data () {
            return {
                publicPath: process.env.BASE_URL
            }
        },computed: {
            id_modale() {
                return this.title.replace(' ','_')
            }
        }
    }
</script>

<style scoped>

</style>
